import { allOrcaWells, allRevioWells, blankSample, maxMovieTime, maxMovieTimeInternal, maxMovieTimeVegaInternal, minMovieTime, minMovieTimeInternal, minMovieTimeVegaInternal, movieTimesRevio, movieTimesVega, plateBarcodeOneReaction, orcaDefaults, orcaPlateWellList, plateWellList, revioDefaults, RunForm, vegaDefaults } from "../constants/constants"
import { v4 } from "uuid"
import { runSummaryLink } from "../../../core/Routes"
import { getRecommendedPreextensionTime } from "./pre-extension"
import cloneDeep from "lodash/cloneDeep"
import isEmpty from "lodash/isEmpty"
import isEqual from "lodash/isEqual"
import some from "lodash/some"
import uniqWith from "lodash/uniqWith"
import { PartsService } from "../../../data/model/parts-model"
import { DesignModel, RunModel, SampleModel } from "../../../data/model/run-model"
import { Application } from "../../../data/model/run-design-defaults-model"
import { InstrumentType, isOrca, isRevio, isVega } from "../../../data/model/instrument-type-model"
import { AnalysisRequest } from "src/data/model/job-options-model"
import { BarcodedSample } from "src/data/model/run-design-model"
import { isPrimaryEntryPoint } from "src/data/model/pipeline-template-models"

export const replaceField = (field, newValue, sample, index, replace) => {
    let newSample = Object.assign({}, sample)
    newSample[field] = newValue
    replace(index, newSample)
    return newSample
}

export const viewSummary = (history, runUuid) => {
    history.push(runSummaryLink(runUuid))
}

export const toggleSampleView = (index: number, sample: any, replace: any) => {
    replaceField("isSampleOpen", !sample.isSampleOpen, sample, index, replace)
}

export const toggleAdvancedView = (index: number, sample: any, replace: any) => {
    replaceField("isAdvancedOpen", !sample.isAdvancedOpen, sample, index, replace)
}

export const toggleRunOptionsView = (index: number, sample: any, replace: any) => {
    replaceField("isRunOptionsOpen", !sample.isRunOptionsOpen, sample, index, replace)
}

export const toggleAnalysisView = (index: number, sample: any, replace: any) => {
    replaceField("isAnalysisOpen", !sample.isAnalysisOpen, sample, index, replace)
}

export const toggleBarcodeView = (index: number, sample: any, replace: any) => {
    replaceField("isBarcodeOpen", !sample.isBarcodeOpen, sample, index, replace)
}

export const toggleAdvancedBarcodeView = (index: number, sample: any, replace: any) => {
    replaceField("isAdvancedBarcodeOpen", !sample.isAdvancedBarcodeOpen, sample, index, replace)
}

export const getImmobilizationTimes = () => {
    return [1, 2, 4]
}

export const getMovieTimes = (s: string) => {
    return isRevio(s) || isOrca(s) ? movieTimesRevio : movieTimesVega
}

export const getWellsForSystem = (systemName: string) => {
    return isOrca(systemName) ? allOrcaWells : allRevioWells
}

export const getPlateWellListForSystem = (systemName: string) => {
    return isOrca(systemName) ? orcaPlateWellList : plateWellList
}

const getSampleDefaults = (instrumentType: string) => {
    if (isOrca(instrumentType)) return orcaDefaults
    return isVega(instrumentType) ? vegaDefaults : revioDefaults
}

export const hoursToMinutes = (value): number => {
    return value * 60
}

export const minutesToHours = (value): number => {
    return value / 60
}

export const secondsToHours = (value): number => {
    return value / 3600
}

export const radioToBoolean = (value: string): boolean => {
    return value === "YES" ? true : false
}

export const pickNewWell = (newSample, runDesignForm: RunForm) => {
    const sampleWells = runDesignForm.samples
        ? runDesignForm.samples.map(s => s.plateWell)
        : []
    let availableWells = getWellsForSystem(runDesignForm.systemName).filter(well =>
        !runDesignForm.assignedWells.includes(well) &&
        !runDesignForm.usedWells.includes(well) &&
        !sampleWells.includes(well))
    if (plateBarcodeOneReaction.includes(runDesignForm.plate1Barcode)) {
        availableWells = availableWells.filter(well =>
            !["1_B01", "1_C01", "1_D01"].includes(well)
        )
    }
    if (plateBarcodeOneReaction.includes(runDesignForm.plate2Barcode)) {
        availableWells = availableWells.filter(well =>
            !["2_B01", "2_C01", "2_D01"].includes(well)
        )
    }
    if (availableWells.length > 0) {
        let newPlateWell = availableWells[0]
        newSample.plateNumber = newPlateWell.split("_")[0]
        newSample.wellName = newPlateWell.split("_")[1]
        newSample.plateWell =newPlateWell
        return newSample
    }
    return null
}

export const updateAssignedWells = (newAssignedWells, runDesignForm, setFieldValue) => {
    let assignedWells = runDesignForm.assignedWells.concat(newAssignedWells)
    setFieldValue("assignedWells", assignedWells.sort())
}

// TODO: mcantor 6.17.24, this method is dangerous.  If we add a sample property
// we are likely to forget to explicitly copy over this properly from sample to newSample.
// Should be refactored to avoid the need to call out individual properties.
export const resetSample = (sample, systemName) => {
    let defaults = getSampleDefaults(systemName)
    let newSample = Object.assign({}, defaults)
    newSample.application = sample.application
    newSample.id = sample.id
    newSample.ccsUuid = sample.ccsUuid
    newSample.sampleName = sample.sampleName
    newSample.wellName = sample.wellName
    newSample.insertSize = sample.insertSize
    newSample.plateNumber = sample.plateNumber
    newSample.plateWell = sample.plateWell
    newSample.sampleDescription = sample.sampleDescription
    newSample.insertSize = sample.insertSize
    newSample.onPlateLoadingConcentration = sample.onPlateLoadingConcentration
    return newSample
}

export const setDefaults = (sample, instrumentType) => {
    let defaults = getSampleDefaults(instrumentType)
    Object.keys(blankSample).forEach(key => {
        sample[key] = defaults[key]
    })
}

export const Create = (runDesignForm, systemName, setFieldValue) => {
    let newSample = Object.assign({}, blankSample)
    setDefaults(newSample, systemName)
    newSample = pickNewWell(newSample, runDesignForm)
    updateAssignedWells([newSample.plateWell], runDesignForm, setFieldValue)
    newSample.id = v4()
    newSample.ccsUuid = v4()
    setFieldValue("samples", runDesignForm.samples.concat(newSample))
}

export const Copy = (push, sample, runDesignForm, setFieldValue) => {
    let newSample = Object.assign({}, sample)
    newSample = pickNewWell(newSample, runDesignForm)
    updateAssignedWells([newSample.plateWell], runDesignForm, setFieldValue)
    newSample.id = v4()
    newSample.ccsUuid = v4()
    newSample.multiJobId = 0
    newSample.barcodeUuidMap = {}
    Object.keys(sample.barcodeUuidMap).forEach(barcode => {
        newSample.barcodeUuidMap[barcode] = v4()
    })
    push(newSample)
}

export const canAddSample = (values: RunForm) => {
    let newSample = Object.assign({}, blankSample)
    return Boolean(pickNewWell(newSample, values))
}

export const Delete = (remove, index, runDesignForm, setFieldValue) => {
    let assignedWells = runDesignForm.assignedWells.filter(
        well => well !== runDesignForm.samples[index].plateWell)
    setFieldValue("assignedWells", assignedWells)
    remove(index)
}

export const getPairs = (array) => {
    let pairs = []
    for (let i = 0; i < array.length - 1; i++) {
        for (let j = i; j < array.length - 1; j++) {
            pairs.push([array[i], array[j + 1]])
        }
    }
    return pairs
}

const getSystemDefaultsForColor = (applicationDefaults: Application, systemName: string) => {
    if (isOrca(systemName)) return applicationDefaults.systems.Orca
    return applicationDefaults.systems.Revio
}

export const getColor = (applicationDefaults: Application, systemName, sample, field) => {
    if (applicationDefaults) {
        const defaults = getSystemDefaultsForColor(applicationDefaults, systemName)
        if (defaults && defaults[field]) {
            return defaults[field] === sample[field] ? "palegreen" : "yellow"
        }
    }
    return "white"
}

export const getExtensionTimeColor = (applicationDefaults: Application, systemName: InstrumentType, sample, field, appConfig) => {
    if (applicationDefaults) {
        const defaults = getSystemDefaultsForColor(applicationDefaults, systemName)
        const recommendedExtensionTime = defaults[field] === "formula"
            ? getRecommendedPreextensionTime(sample.insertSize, "NO", systemName, appConfig, sample.application)
            : defaults[field]
        if (applicationDefaults.title === "Custom") {
            return "white"
        }
        if (!recommendedExtensionTime || !(recommendedExtensionTime.length === 0) || isNaN(Number(recommendedExtensionTime))) {
            return "yellow"
        }
        if (Number(recommendedExtensionTime) ===  Number(sample[field])) {
            return "palegreen"
        } else {
            return "yellow"
        }
    } else {
        return "white"
    }
}

export const booleanToString = (value) => {
    return value ? "TRUE" : "FALSE"
}

export const formatDecimal = (number) => {
    const locale = localStorage.getItem("decimalSeparator") === "," ? "es-ES" : "en-us"
    let formatter = new Intl.NumberFormat(locale)
    return formatter.format(number)
}

export const isDirty = (values: RunForm, initialValues: RunForm) => {
    // These are transient UI-state fields, not persisted run-design data. Analysis-derived
    // fields (taskOptions, presetId, ...) no longer need listing here: RunDesignForm
    // re-baselines initialValues once the form settles after load (SL-12727 / SL-11675).
    const blacklist =
        ["isSampleOpen", "isAdvancedOpen", "isBarcodeOpen", "isAdvancedBarcodeOpen",
        "barcodeSetName", "isValidBarcodeDesign", "isRunOptionsOpen", "isAnalysisOpen"]
    let valuesC = cloneDeep(values)
    let initialValuesC = cloneDeep(initialValues)
    blacklist.forEach(field => {
        valuesC.samples.forEach(sample => {
            delete sample[field]
        })
        initialValuesC.samples.forEach(sample => {
            delete sample[field]
        })
    })
    return !isEqual(valuesC, initialValuesC)
}

/** Parses YYYYMMDD from the first 8 characters, or `null` if the string is missing or too short. */
export const getDate = (dateString: string): Date | null => {
    if (!dateString || dateString.length < 8) {
        return null
    }
    return new Date(
        Number(dateString.slice(0,4)),
        Number(dateString.slice(4,6))-1,
        Number(dateString.slice(6,8)))
}

export const isExpired = (expirationDate: Date | null) => {
    if (!expirationDate || isNaN(expirationDate.getTime())) {
        return false
    }
    const milliSecondsInDay = 60*60*24*1000
    return expirationDate.getTime() + milliSecondsInDay < Date.now()
}

/** True when the plate was expired at the given reference time (e.g. runStart). */
export const isExpiredAtDate = (expirationDate: Date | null, referenceDate: Date): boolean => {
    if (!expirationDate || isNaN(expirationDate.getTime()) || !referenceDate || isNaN(referenceDate.getTime())) {
        return false
    }
    const milliSecondsInDay = 60*60*24*1000
    return expirationDate.getTime() + milliSecondsInDay < referenceDate.getTime()
}


export const getExpirationDate = (barcode: string): Date | null => {
    const dateString = getExpiry(barcode)
    return getDate(dateString)
}

export const getLot = (barcode: string) => {
    return barcode.slice(9,15)
}

export const getExpiry = (barcode: string) => {
    return barcode.slice(20,28)
}

export const getPartNumber = (barcode: string) => {
    const partNumberBarcode = getPartNumberString(barcode)
    return partNumberBarcode.slice(0,3) + "-" +
           partNumberBarcode.slice(3,6) + "-" +
           partNumberBarcode.slice(6,9)
}

export const getPartNumberString = (barcode: string) => {
    return barcode.slice(0,9)
}

export const getOldBarcode = (barcode: string) => {
    return barcode.slice(9,15) +
           barcode.slice(0,9) +
           barcode.slice(24,28) +
           barcode.slice(22,24)
}

// old format
// 123456 102118800 123123
// lot number + part number + exp date

// new format
// 102118800 123456 12345 20231231
// part number + lot number + label number + exp date

export const makeNewBarcode = (barcode: string, labelNumber: string) => {
    return barcode.slice(6,15) +
           barcode.slice(0,6) +
           labelNumber +
           "20" +
           barcode.slice(19,21) +
           barcode.slice(15,19)
}

export const getPlateBarcode = (run: RunModel, plateNumber: number) => {
    return plateNumber === 1 ? run.plate1Barcode : run.plate2Barcode
}

/**
 * Value for Run Design CSV [Run Settings] "Plate 1" / "Plate 2" cells: full 28-digit plate id when that is what
 * is stored; otherwise the nine-digit part only (including from {@link makeOldBarcode} kit strings).
 */
export const plateBarcodeForRunDesignCsvExport = (plateBarcode: string): string => {
    if (!plateBarcode) {
        return ""
    }
    const b = plateBarcode.trim()
    if (b.length === 28 && /^\d+$/.test(b)) {
        return b
    }
    const kit = b.match(/^Lxxxxx(\d{9})123199$/)
    if (kit) {
        return kit[1]
    }
    if (/^\d{9}$/.test(b)) {
        return b
    }
    const hyp = b.match(/^(\d{3})-(\d{3})-(\d{3})$/)
    if (hyp) {
        return hyp[1] + hyp[2] + hyp[3]
    }
    if (b.length >= 9 && !/^\d+$/.test(b) && /^\d{9}$/.test(getPartNumberString(b))) {
        return getPartNumberString(b)
    }
    return ""
}

export const getLabelNumber = (barcode: string) => {
    return barcode.slice(15,20)
}

export const getLabel = (barcode: string, partsService: PartsService) => {
    let partNumber = getPartNumber(barcode)
    let part = partsService.getPart(partNumber)
    if (part) {return part.name} else {return ""}
}

// Error to show when a scanned plate barcode cannot be used for the given instrument; "" when it can.
export const getScannedPlateError = (
    barcode: string, partsService: PartsService, plateOptions: string[], instrumentType: InstrumentType
): string => {
    const partNumber = getPartNumber(barcode)
    const part = partsService.getPart(partNumber)
    if (!part) {
        return "Barcode is not for a valid part"
    }
    // plateOptions is empty until the plate choices for the instrument have loaded
    if (plateOptions.length > 0 && !plateOptions.includes(part.name)) {
        return `${part.name} (${partNumber}) is not a valid sequencing plate for ${instrumentType}`
    }
    return ""
}

export const makeOldBarcode = (partNumber: string) => {
    return "Lxxxxx" + partNumber.replace(new RegExp("-", "g"), "") + "123199"
}

export const resetAvailableWells = (e, sample, props) => {
    let plateWellId = e.target.value
    if (plateWellId) {
        let assignedWells =
        props.values.assignedWells.concat([plateWellId])
        assignedWells =
        assignedWells.filter(well => well !== sample.plateWell)
        props.setFieldValue(
            "assignedWells", assignedWells.sort())
    }
}

export const hyphenatePartNumber = (pn: string) => `${pn.slice(0, 3)}-${pn.slice(3, 6)}-${pn.slice(6)}`

export const getUsedNonSingleReactionPlates = (formValues: RunForm, partsService: PartsService): number[] => {
    const plate1HasUsedWells = formValues.usedWells.some(w => w.startsWith("1_"))
    const plate2HasUsedWells = formValues.usedWells.some(w => w.startsWith("2_"))
    const plate1Kit = formValues.plate1PartNumber ?
        partsService.getSequencingKit(hyphenatePartNumber(formValues.plate1PartNumber)) : null
    const plate2Kit = formValues.plate2PartNumber ?
        partsService.getSequencingKit(hyphenatePartNumber(formValues.plate2PartNumber)) : null
    const plates: number[] = []
    if (plate1HasUsedWells && plate1Kit?.maxCollections !== 1) plates.push(1)
    if (plate2HasUsedWells && plate2Kit?.maxCollections !== 1) plates.push(2)
    return plates
}

export const disablePlateWell = (id, values, sample) => {
    return (
        (values.assignedWells.includes(id) && id !== sample.plateWell) ||
        (values.usedWells.includes(id) && id !== sample.plateWell) ||
        (plateBarcodeOneReaction.includes(values.plate1PartNumber) && ["1_B01", "1_C01", "1_D01"].includes(id)) ||
        (plateBarcodeOneReaction.includes(values.plate2PartNumber) && ["2_B01", "2_C01", "2_D01"].includes(id))
    )
}

export const getMinMovieTime = (systemName: InstrumentType, isInternalModeEnabled: boolean) => {
    if (isInternalModeEnabled) {
        return isVega(systemName) ? minMovieTimeVegaInternal : minMovieTimeInternal
    } else {
        return minMovieTime
    }
}

export const getMaxMovieTime = (systemName: InstrumentType, isInternalModeEnabled: boolean) => {
    if (isInternalModeEnabled) {
        return isVega(systemName) ? maxMovieTimeVegaInternal : maxMovieTimeInternal
    } else {
        return maxMovieTime
    }
}

export const canEditAnalysisOptions = (design: DesignModel): boolean => {
    if (isEmpty(design.run.samples)) {
        return true
    }
    return isEmpty(design.run.samples.find(sample => !canEditSample(sample)))
}

export const canEditSample = (sample: SampleModel) => {
    // If there are no barcodedSamples: Can Edit
    if (isEmpty(sample.barcodedSamples)) {
        return true
    }
    // If none of the barcodedSamples have analaysis options: Can Edit
    const barcodedSamplesHaveAnalysisOptions = sample.barcodedSamples.filter(bs => !isEmpty(bs.pipelineId)).length > 0
    if (!barcodedSamplesHaveAnalysisOptions) {
        return true
    }

    // If barcodedSamples have differing options: Can NOT Edit
    if ( !areAnalysisOptionsIdentical(sample.barcodedSamples)) {
        return false
    }    
    const sampleHasAnalysis = hasAnalysisOptions(sample) 
    const sampleAndBarcodedSamplesAgree =  areAnalysisOptionsIdentical( [sample, sample.barcodedSamples[0]] )        
    // If barcodedSamples have differing options from sample: Can NOT Edit
    if ( sampleHasAnalysis && !sampleAndBarcodedSamplesAgree) {
        return false
    }
    return true
}

const areAnalysisOptionsIdentical = ( barcodedSamples: BarcodedSample[] ): boolean => {
    if (isEmpty(barcodedSamples)) {
        return true
    }
    const optionsList = barcodedSamples.map( bs => { 

        const nonPrimaryEntryPoints = isEmpty(bs.entryPoints) ? 
            bs.entryPoints : bs.entryPoints.filter( ep => !isPrimaryEntryPoint(ep))
        
            // TODO: mcantor 01.21.25 
            // we exclude analysisName from the comparison here because for any demux auto-analysis
            // the job names will be suffixed with the child dataset name. 
            // Need a better strategy long term. (see SL-11633) 
        return {
            pipelineId: bs.pipelineId,
            entryPoints: nonPrimaryEntryPoints,
            taskOptions: bs.taskOptions, 
        }
    })
    return uniqWith(optionsList, isEqual).length === 1
}

export const hasAnalysisOptions = ( sample: AnalysisRequest): boolean => {
    const { pipelineId, analysisName, entryPoints, taskOptions } = sample
    const options = { pipelineId, analysisName, entryPoints, taskOptions }
    return some(Object.values(options))
} 
